const DEBUG = false;
console.log('NEW');
function debugLog(message, ...optionalParams) {
  if (DEBUG) {
    console.log(message, ...optionalParams);
  }
}

function updateProductPrice(clickedElement) {
  debugLog("updateProductPrice called for element:", clickedElement);
  const priceElement = clickedElement.querySelector('.loop-widget-purchase-option-price');
  if (priceElement) {
    const priceText = priceElement.textContent.trim();
    debugLog("Found price text:", priceText);
    const productPriceWrapper = document.querySelector('.product .price');
    if (productPriceWrapper) {
      productPriceWrapper.innerHTML = `
        <div class="price__sale">
          <span class="price-item price-item--sale price-item--last">${priceText} ${Shopify.currency.active}</span>
          <span class="visually-hidden visually-hidden--inline">Regular price</span>
          <span>
            <s class="price-item price-item--regular"></s>
          </span>
          <span class="visually-hidden visually-hidden--inline">Sale price</span>
        </div>`;
      debugLog("Product price updated:", productPriceWrapper);
    } else {
      debugLog("Product price wrapper not found.");
    }
  } else {
    debugLog("No price element found inside clicked element.");
  }
}

function initializeCustomOptions() {
  debugLog("initializeCustomOptions called.");
  const subscriptionData = window.subscriptionData || [];
  debugLog("Subscription data:", subscriptionData);
  const selectElement = document.querySelector('.loop-widget-sp-selector');
  if (!selectElement) {
    console.error("Select element (.loop-widget-sp-selector) not found.");
    return;
  }
  debugLog("Select element found:", selectElement);
  const options = selectElement.querySelectorAll('option');
  debugLog("Number of options found:", options.length);
  const customWrapper = document.createElement("div");
  customWrapper.classList.add("loop-custom-options-wrapper");
  function setActiveCustomOption(activeDiv) {
    const customOptions = customWrapper.querySelectorAll('.loop-custom-option');
    customOptions.forEach(option => option.classList.remove('active'));
    activeDiv.classList.add('active');
    debugLog("Active custom option updated:", activeDiv);
  }
  options.forEach((option, index) => {
    debugLog("Processing option:", option, "at index:", index);
    const customOption = document.createElement("div");
    customOption.classList.add("loop-custom-option");
    const subscription = subscriptionData.find(sub => sub.loop_name.trim() === option.textContent.trim());
    debugLog("Subscription match for option:", subscription);
    if (subscription) {
      if (subscription.plan_image) {
        const img = document.createElement("img");
        img.src = subscription.plan_image;
        img.alt = subscription.custom_name;
        customOption.appendChild(img);
        debugLog("Image added with src:", subscription.plan_image);
      }
      const span = document.createElement("span");
      span.textContent = subscription.custom_name;
      customOption.appendChild(span);
      debugLog("Custom name added:", subscription.custom_name);
    } else {
      customOption.textContent = option.textContent;
      debugLog("Fallback: option text used:", option.textContent);
    }
    if (index === 0) {
      customOption.classList.add('active');
      debugLog("First custom option set active.");
    }
    customOption.addEventListener("click", function() {
      debugLog("Custom option clicked:", customOption);
      selectElement.value = option.value;
      const event = new Event('change', { bubbles: true });
      selectElement.dispatchEvent(event);
      setActiveCustomOption(customOption);
      updateProductPrice(customOption);
    });
    customWrapper.appendChild(customOption);
  });
  let widgetContainer = document.querySelector(".loop-widget-container");
  if (!widgetContainer) {
    widgetContainer = document.querySelector(".loop-widget-spg-container");
  }
  if (widgetContainer) {
    widgetContainer.appendChild(customWrapper);
    debugLog("Custom wrapper appended to widget container:", widgetContainer);
  } else {
    console.error("Widget container not found.");
  }
  const purchaseOptions = document.querySelectorAll('.loop-widget-purchase-option');
  debugLog("Number of purchase options found:", purchaseOptions.length);
  if (purchaseOptions.length >= 2) {
    const secondPurchaseOption = purchaseOptions[1];
    function updateCustomWrapperActiveState() {
      if (secondPurchaseOption.classList.contains('loop-widget-purchase-option-selected')) {
        customWrapper.classList.add('active');
        debugLog("Custom wrapper set to active based on second purchase option.");
      } else {
        customWrapper.classList.remove('active');
        debugLog("Custom wrapper removed active based on second purchase option.");
      }
    }
    const observer = new MutationObserver(updateCustomWrapperActiveState);
    observer.observe(secondPurchaseOption, { attributes: true, attributeFilter: ['class'] });
    updateCustomWrapperActiveState();
  }
  const oneTimePurchaseElements = document.querySelectorAll('[data-loop-widget-onetime-purchase-option]');
  oneTimePurchaseElements.forEach(el => {
    el.addEventListener('click', function() {
      debugLog("One-time purchase element clicked:", el);
      updateProductPrice(el);
    });
  });
  const sellingPlanGroupElements = document.querySelectorAll('[data-loop-widget-selling-plan-group]');
  sellingPlanGroupElements.forEach(el => {
    el.addEventListener('click', function() {
      debugLog("Selling plan group element clicked:", el);
      updateProductPrice(el);
    });
  });

  const selectedOption = document.querySelector('.loop-widget-purchase-option-selected');
  if (selectedOption) {
    selectedOption.click();
  }
}

function waitForWidgetContainer() {
  debugLog("Waiting for widget container (.loop-widget-spg-container)...");
  const container = document.querySelector('.loop-widget-spg-container');
  if (container) {
    debugLog("Widget container found immediately:", container);
    initializeCustomOptions();
    return;
  }
  const observer = new MutationObserver((mutations, obs) => {
    const container = document.querySelector('.loop-widget-spg-container');
    if (container) {
      debugLog("Widget container found via observer:", container);
      initializeCustomOptions();
      obs.disconnect();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
}

waitForWidgetContainer();
